var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("input", {
        ref: "eventoClick",
        staticStyle: { display: "none" },
        attrs: {
          type: "file",
          id: _vm.scope,
          multiple: "false",
          accept: _vm.validExtensions
        },
        on: { change: _vm.setDocument }
      }),
      _c("el-row", { staticClass: "titulo" }, [
        _c("div", { staticClass: "left" }, [
          _c("div", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.titulo) + "  "),
            _vm.required
              ? _c("span", { staticClass: "required" }, [_vm._v("*  ")])
              : _vm._e()
          ])
        ]),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    return _vm.callEventClick()
                  }
                }
              },
              [
                _c("span", { staticClass: "center" }, [
                  _c("i", { staticClass: "material-icons icon" }, [
                    _vm._v("attach_file")
                  ]),
                  _c("b", [_vm._v("  Anexar")])
                ])
              ]
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "divider" }),
      _c("el-row", [
        _c(
          "div",
          { class: { "box-erro": !_vm.isValid || _vm.hasError } },
          [
            _c(
              "el-table",
              { attrs: { data: _vm.arquivos, stripe: "stripe" } },
              [
                _c("div", { attrs: { slot: "empty" }, slot: "empty" }, [
                  _c("span", [
                    _vm._v(
                      'Nenhum arquivo adicionado. Para adicionar um novo arquivo, clique no botão "Anexar" acima.'
                    )
                  ])
                ]),
                _c("el-table-column", {
                  attrs: { prop: "nome", label: _vm.tituloLabel }
                }),
                _c("el-table-column", {
                  attrs: { label: "Ação", align: "center", width: "85" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("app-action-button", {
                            attrs: {
                              icone: "material-icons",
                              nome: "clear",
                              hoverColor: "firebrick",
                              text: "Remover documento"
                            },
                            on: {
                              click: function($event) {
                                return _vm.deleteRow(scope.row)
                              }
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "p",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isValid,
                expression: "!isValid"
              }
            ],
            staticClass: "help erro"
          },
          [_vm._v(_vm._s(_vm.extensionValidateMessage))]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e6ecdab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e6ecdab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppAnexarArquivo.vue
// module id = null
// module chunks = 